export type AnalyticsEvent =
  | "hero_interaction"
  | "selected_work_view"
  | "project_select"
  | "case_study_complete"
  | "live_site_click"
  | "repository_click"
  | "resume_download"
  | "contact_start"
  | "contact_complete"
  | "email_click"
  | "linkedin_click"
  | "build_explore";
type Adapter = (event: AnalyticsEvent, data?: Record<string, string>) => void;
let adapter: Adapter | undefined;
export function setAnalyticsAdapter(next: Adapter | undefined) {
  adapter = next;
}
// No provider, cookies, storage, network calls, or personally identifying form data by default.
export function track(event: AnalyticsEvent, data?: Record<string, string>) {
  adapter?.(event, data);
}
